{
    "firebase": {
        "apiKey": "AIzaSyAG_1nlPDL1utbsxzUPZgncxCtY45SW5Ww",
        "authDomain": "flightline-harvest-prod.firebaseapp.com",
        "databaseURL": "https://flightline-harvest-prod-default-rtdb.firebaseio.com",
        "projectId": "flightline-harvest-prod",
        "storageBucket": "flightline-harvest-prod.firebasestorage.app",
        "messagingSenderId": "12613364577",
        "appId": "1:12613364577:web:a309dd555dc824f5cdb320"
    },
    "clientName": "Harvest",
    "pdfViewerKey": "dfc1f220ecc745298858395864414c6a",
    "domains": ["harvest.flightlinedata.com"]
}
